const initialState = {
  checkIn: null,
  checkOut: null,
  totalNights: null,
  destination: null,
  passengers: [],
  id_user: null,
  family_plan: false,
};

const searchAssistReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_ASSIST_DETAIL':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default searchAssistReducer;
